import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '../../services/admin/AdminAuthServices';

/**
 * AdminPublicRoutes
 * Wrapper for admin auth pages (Login, Forgot Password, Reset Password).
 * Redirects to dashboard if the admin is already logged in.
 * This prevents the user from going "back" to the login page after logging in.
 */
const AdminPublicRoutes = ({ children }) => {
    const { admin } = useAdminAuth();

    if (admin) {
        // If already logged in, redirect to dashboard
        return <Navigate to="/admin/dashboard/" replace />;
    }

    return children;
};

export default AdminPublicRoutes;
